import DeclineReasonPopover from '/component/partial/DeclineReasonPopover';
import {getDateUtilDefaultInstance} from '/util/date.util';

export const generateOpenDeclinePopover = (
  {popoverShow}: any,
  handleDeclineCandidate: any,
) => {
  return () => {
    popoverShow(DeclineReasonPopover, {
      onSubmit: (declineReason: any) => handleDeclineCandidate(declineReason),
    });
  };
};

export const getAcceptByLocalTime = (acceptBeforeDateTime: string) => {
  const candidateAcceptByTime =
    getDateUtilDefaultInstance().getLocalTimeInHours(acceptBeforeDateTime);
  return candidateAcceptByTime?.replace(/^0+/, '');
};
